
import API from '../../services/client'

export default async (session)=>{
        try{
                return await API.CatalogueManager.sessions.create(session)
        }catch(err){
                return err
        }
}